module.exports = __webpack_public_path__ + "img/rackspace.6f98715f.svg";